export const GET_ALL_PARTNER = 'GET_ALL_PARTNER';
export const GET_ALL_PARTNER_SUCCESS = 'GET_ALL_PARTNER_SUCCESS';
export const GET_ALL_PARTNER_ERROR = 'GET_ALL_PARTNER_ERROR';
export const CREATE_PARTNER = 'CREATE_PARTNER';
export const CREATE_PARTNER_SUCCESS = 'CREATE_PARTNER_SUCCESS';
export const CREATE_PARTNER_ERROR = 'CREATE_PARTNER_ERROR';
export const UPDATE_PARTNER = 'UPDATE_PARTNER';
export const UPDATE_PARTNER_SUCCESS = 'UPDATE_PARTNER_SUCCESS';
export const UPDATE_PARTNER_ERROR = 'UPDATE_PARTNER_ERROR';
export const DELETE_PARTNER = 'DELETE_PARTNER';
export const DELETE_PARTNER_SUCCESS = 'DELETE_PARTNER_SUCCESS';
export const DELETE_PARTNER_ERROR = 'DELETE_PARTNER_ERROR';
// get_partners_by_name
export const GET_PARTNERS_BY_NAME = 'get_partners_by_name';
export const GET_PARTNERS_BY_NAME_SUCCESSFUL =
  'get_partners_by_name_successfull';
export const GET_PARTNERS_BY_NAME_FAILED = 'get_partners_by_name_failed';

// get_marketplaces_by_search_filter_sortby
export const GET_MARKETPLACES_BY_SEARCH_FILTER_SORTBY =
  'get_marketplaces_by_search_filter_sortby';
export const GET_MARKETPLACES_BY_SEARCH_FILTER_SORTBY_SUCCESSFUL =
  'get_marketplaces_by_search_filter_sortby_successfull';
export const GET_MARKETPLACES_BY_SEARCH_FILTER_SORTBY_FAILED =
  'get_marketplaces_by_search_filter_sortby_failed';

// search_projects
export const SEARCH_PROJECTS = 'search_projects';
export const SEARCH_PROJECTS_SUCCESSFUL = 'search_projects_successfull';
export const SEARCH_PROJECTS_FAILED = 'search_projects_failed';

// search_contests
export const SEARCH_CONTESTS = 'search_contests';
export const SEARCH_CONTESTS_SUCCESSFUL = 'search_contests_successfull';
export const SEARCH_CONTESTS_FAILED = 'search_contests_failed';
